"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// source: https://www.iso.org/obp/ui/#iso:code:3166:AU
var _default = [{
  name: 'Australian Capital Territory',
  code: 'ACT'
}, {
  name: 'New South Wales',
  code: 'NSW'
}, {
  name: 'Northern Territory',
  code: 'NT'
}, {
  name: 'Queensland',
  code: 'QLD'
}, {
  name: 'South Australia',
  code: 'SA'
}, {
  name: 'Tasmania',
  code: 'TAS'
}, {
  name: 'Victoria',
  code: 'VIC'
}, {
  name: 'Western Australia',
  code: 'WA'
}];
exports.default = _default;